import { routerMiddleware as createRouterMiddleware } from 'connected-react-router'
import { applyMiddleware, compose, createStore } from 'redux'
import { createEpicMiddleware } from 'redux-observable'

import { rootEpic, rootReducer } from 'modules'
import history from 'modules/history'

const epicMiddleware = createEpicMiddleware()
const routerMiddleware = createRouterMiddleware(history)
const composeEnhancers =
  window.__ENV__ !== 'PRODUCTION' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({ trace: true })
    : compose

export const store = createStore(
  rootReducer(history),
  composeEnhancers(applyMiddleware(routerMiddleware, epicMiddleware))
)

epicMiddleware.run(rootEpic)

export default store
